!(function (n, e) {
  "object" == typeof exports && "undefined" != typeof module
    ? e(exports)
    : "function" == typeof define && define.amd
    ? define(["exports"], e)
    : e((n.quicklink = {}))
})(this, function (n) {
  function o(o) {
    return new Promise(function (n, e, t) {
      ;
      
      (t = new XMLHttpRequest()).open("GET", o, (t.withCredentials = !0)),
        (t.onload = function () {
          ;(200 === t.status ? n : e)()
        }),
        t.send()
    })
  }
  var e,
    i =
      (e = document.createElement("link")).relList &&
      e.relList.supports &&
      e.relList.supports("prefetch")
        ? function (o) {
          
          	
            return new Promise(function (n, e, t) {              
              ;((t = document.createElement("link")).rel = "prefetch"),
                (t.href = o),
                (t.onload = n),
                (t.onerror = e),
                document.head.appendChild(t)
            })
          }
        : o,
    s =
      window.requestIdleCallback ||
      function (n) {
        var e = Date.now()
        return setTimeout(function () {
          n({
            didTimeout: !1,
            timeRemaining: function () {
              return Math.max(0, 50 - (Date.now() - e))
            },
          })
        }, 1)
      },
    a = new Set()
  function l(n, e, t) {
    return Promise.all(
      [].concat(n).map(function (n) {
        if (!a.has(n))
          
          try {
            let ul = (new URL( n )).pathname.split('/');
            if (ul.includes("cart") ){ return false; }
          } catch (e) { /* .... */ }
          
          return (
            a.add(n),
            (e
              ? function (n) {
                  return window.fetch ? fetch(n, { credentials: "include" }) : o(n)
                }
              : i)(new URL(n, location.href).toString())
          )
      }),
    )
  }
  ;(n.listen = function (e) {
    if (((e = e || {}), window.IntersectionObserver)) {
      var n = (function (n) {
          n = n || 1
          var e = [],
            t = 0
          function o() {
            t < n && 0 < e.length && (e.shift()(), t++)
          }
          return [
            function (n) {
              1 < e.push(n) || o()
            },
            function () {
              t--, o()
            },
          ]
        })(e.throttle || 1 / 0),
        t = n[0],
        o = n[1],
        i = e.limit || 1 / 0,
        r = e.origins || [location.hostname],
        c = e.ignores || [],
        u = e.timeoutFn || s,
        f = new IntersectionObserver(function (n) {
          n.forEach(function (n) {
            n.isIntersecting &&
              (f.unobserve((n = n.target)),
              a.size < i &&
                t(function () {
                  l(n.href, e.priority)
                    .then(o)
                    .catch(function (n) {
                      o(), e.onError && e.onError(n)
                    })
                }))
          })
        })
      return (
        u(
          function () {
            ;(e.el || document).querySelectorAll("a").forEach(function (n) {
              ;(r.length && !r.includes(n.hostname)) ||
                (function e(t, n) {
                
                  return Array.isArray(n)
                    ? n.some(function (n) {
                        return e(t, n)
                      })
                    : (n.test || n).call(n, t.href, t)
                })(n, c) ||
                f.observe(n)
            })
          },
          { timeout: e.timeout || 2e3 },
        ),
        function () {
          a.clear(), f.disconnect()
        }
      )
    }
  }),
    (n.prefetch = l)
})

window.addEventListener("load", () => {
  quicklink.listen()

  var prefetchLinks = [
    "/collections/fueller",
    "/collections/edle-schreibgerate",
    "/collections/kugelschreiber",
  ]

  prefetchLinks.map(function (link) {
    quicklink.prefetch(link)
  })
})
